import { Box, Skeleton } from '@mui/material';

const TITLE_WIDTH = 220;
const TITLE_HEIGHT = 36;
const TILE_HEIGHT = 96;
const BODY_HEIGHT = 320;

/**
 * What a route shows while its code downloads: the shape of a page (a title row,
 * a strip of tiles, a body panel), so the screen does not jump when the real one
 * arrives. Announced as busy, so a screen reader hears that something is loading
 * rather than a blank main region.
 */
export function PageSkeleton() {
  return (
    <Box role="status" aria-busy="true" aria-label="Loading page" sx={{ p: 3 }}>
      <Skeleton variant="text" width={TITLE_WIDTH} height={TITLE_HEIGHT} sx={{ mb: 2 }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
          gap: 1.75,
          mb: 2.25,
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rounded" height={TILE_HEIGHT} />
        ))}
      </Box>
      <Skeleton variant="rounded" height={BODY_HEIGHT} />
    </Box>
  );
}

export default PageSkeleton;
